import { Button, FormControl, FormLabel } from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { padLeft } from 'BrokerTsLib/src/helpers/global'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useFindAddress } from '@/hooks'

import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { useFindCompany } from 'BrokerTsLib/src/hooks'
import { InputGroup } from '../../../components/InputGroup'
import { useNameof } from '../../../hooks/useNameof'
import { Cloud } from '../../../images/Cloud'
import { FormRow } from '../FormRow'

function ICOOptions({ personPrefix, disabled, hideIc }: { personPrefix: string, disabled?: boolean, hideIc?: boolean }) {
  const { isDisabled: isDisabledCtx } = useInsuranceParams()
  const isDisabled = isDisabledCtx || disabled

  const pnameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, watch, getFieldState, setValue, trigger } = useFormContext()

  const icPath = pnameof(x => x.idendificationNumber)
  const cnPath = pnameof(x => x.companyName)

  const ic = watch(icPath)

  const { mutateAsync: refetchAddress, isLoading: isLoadingAddress } = useFindAddress()

  const { mutateAsync: loadAres, isLoading } = useFindCompany()

  const fillCompanyData = () => {
    loadAres(ic).then((ares: PersonAdditionalData) => {
      if (ares) {
        setValue(cnPath, ares.companyName)
        setValue(pnameof(x => x.idendificationNumber), ares.idendificationNumber)
        setValue(pnameof(x => x.agent?.name), ares.agent?.name)
        setValue(pnameof(x => x.agent?.surname), ares.agent?.surname)
        setValue(pnameof(x => x.agent?.titleBefore), ares.agent?.titleBefore)
        setValue(pnameof(x => x.address.addressPoint), ares.address.addressPoint)
        setValue(pnameof(x => x.address.city), ares.address.city)
        setValue(pnameof(x => x.address.country), ares.address.country)
        setValue(pnameof(x => x.address.isEvidenceNumber), ares.address.isEvidenceNumber)
        setValue(pnameof(x => x.address.postCode), ares.address.postCode)
        setValue(pnameof(x => x.address.street), ares.address.street)
        setValue(pnameof(x => x.address.streetNumber), ares.address.streetNumber)
        setValue(pnameof(x => x.email), ares.email)
        setValue(pnameof(x => x.mobilePhone), ares.mobilePhone)
        setValue(pnameof(x => x.phone), ares.phone)
        trigger(cnPath)
      }
    })
  }

  const icError = getFieldState(icPath).error
  const cnError = getFieldState(cnPath).error

  return (
    <>
      <FormRow>
        {!hideIc &&
          <FormControl isInvalid={!!icError}>
            <FormLabel>
              IČO
            </FormLabel>

            <InputGroup
              isDisabled={isDisabled}
              id="bcn"
              placeholder="Např. 18628443"
              htmlSize={16}
              errors={icError}
              {...register(icPath, {
                onBlur: (e: any) => {
                  const val = e.target.value
                  setValue(icPath, val ? padLeft(val, 8, '0') : null) // doplneni zleva nulama
                }
              })}
              rightElement={
                <CustomTooltip label="Načíst údaje z ARES">
                  <Button
                    type="button"
                    variant="ghost"
                    isLoading={isLoading || isLoadingAddress}
                    isDisabled={isLoading || !ic || isDisabled}
                    onClick={fillCompanyData}
                    padding={2}
                  >
                    <Cloud color="secondary.500" />
                  </Button>
                </CustomTooltip>
              }
            />
          </FormControl>}

        <FormControl isInvalid={!!cnError} isRequired>
          <FormLabel htmlFor="bcn">
            Název firmy
          </FormLabel>

          <InputGroup
            isDisabled={isDisabled}
            id="bcn"
            htmlSize={16}
            errors={cnError}
            {...register(cnPath)}
          />
        </FormControl>
      </FormRow>
    </>
  )
}

export default ICOOptions